import { Asset } from "@saysimple-platform/dtos";
import { defineStore } from "pinia";

interface State {
    attachments: Asset[];
    downloadsLimit: number;
}

export const useDownloadAttachmentsStore = defineStore("download-attachments", {
    state: (): State => ({
        attachments: [],
        downloadsLimit: 15, // Discussed with Tom de Ridder that we'll start with a limit of 15.
    }),
    actions: {
        clearDownloads(): void {
            this.attachments = [];
        },
    },
    getters: {
        downloadsCount: (state): number => state.attachments.length,
        hasDownloads: (state): boolean => state.attachments.length > 0,
        isSelected(): (asset: Asset) => boolean {
            return (asset: Asset) => this.attachments.includes(asset);
        },
        hasReachedLimit: (state): boolean => state.attachments.length >= state.downloadsLimit,
    },
});
